export const getMembershipState = (userProfile) => {
    const isAdvisorUnderReview =
        (userProfile?.requestedMembershipType === 'advisor' && userProfile?.advisorApplicationStatus === 'pending') ||
        (userProfile?.membershipType === 'advisor' && !userProfile?.promotedToAdvisorAt && userProfile?.advisorApplicationStatus !== 'approved');

    const paymentStatus = userProfile?.paymentStatus || (userProfile?.billingInterval && userProfile.billingInterval !== 'free' ? 'pending' : 'free');
    const hasPendingActiveUpgrade =
        (userProfile?.requestedMembershipType === 'active' || userProfile?.membershipType === 'active') &&
        paymentStatus !== 'paid';

    const displayMembershipType = isAdvisorUnderReview
        ? 'advisor'
        : hasPendingActiveUpgrade
            ? 'general'
            : (userProfile?.membershipType || 'general');

    const isPaidMembership = displayMembershipType === 'active';
    const isActivated =
        !isAdvisorUnderReview &&
        userProfile?.status === 'active' &&
        (!isPaidMembership || paymentStatus === 'paid');

    return {
        isAdvisorUnderReview,
        hasPendingActiveUpgrade,
        displayMembershipType,
        isPaidMembership,
        isActivated,
        paymentStatus,
        canRetryPayment: hasPendingActiveUpgrade && userProfile?.billingInterval && userProfile.billingInterval !== 'free',
    };
};

export const hasFullLibraryAccess = (userProfile) => {
    const membershipState = getMembershipState(userProfile);
    const isApprovedAdvisor =
        membershipState.displayMembershipType === 'advisor' &&
        userProfile?.advisorApplicationStatus === 'approved';
    const eligibleMembership =
        membershipState.displayMembershipType === 'active' ||
        isApprovedAdvisor;

    return membershipState.isActivated && eligibleMembership;
};
